import { Col, Row, Typography, Card, Space, Alert } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";

export interface ActionPlaceholderPageProps {
  readonly title: string;
  readonly description?: string;
}

// Shared placeholder for Actions sub-routes that are listed in PD-02 but
// whose backend wiring is not yet available. Instead of a literal
// `<>healthcare-plan</>` leaf, the user sees a labeled card explaining what
// the surface does and that it will be enabled once the client confirms
// scope.
function ActionPlaceholderPage(props: ActionPlaceholderPageProps) {
  return (
    <Col className="flex flex-auto flex-col gap-4 overflow-y-auto p-6">
      <Row>
        <Typography.Title level={3} className="!m-0">
          <FontAwesomeIcon icon={faScrewdriverWrench} className="mr-2" />
          {props.title}
        </Typography.Title>
      </Row>

      <Alert
        type="info"
        showIcon
        message={props.description ??
          `This action is part of the PD-02 Actions scope. It is scaffolded but the backend wiring is pending client confirmation.`}
      />

      <Card bodyStyle={{ padding: 16 }}>
        <Space direction="vertical" className="w-full">
          <Typography.Text strong>What this surface will do</Typography.Text>
          <Typography.Paragraph type="secondary" className="!mb-0">
            Follow the PD-02 Actions specification: pick an audience, set
            dates, trigger the matching notification and track completion in
            the Actions grid. Report back to your account manager if you
            need this surface prioritized.
          </Typography.Paragraph>
        </Space>
      </Card>
    </Col>
  );
}

export default ActionPlaceholderPage;
